module.exports = __webpack_public_path__ + "static/media/zoom_icon.35949058.svg";